import { Typography } from '@mui/material';
import { getClient } from '../../lib/info';

export const Terms = (): JSX.Element => {
  const client = getClient();

  return (
    <>
      <Typography variant="pageTitle">
        Informativa sul trattamento dei dati personali
      </Typography>
      <div className="body padding-top-m padding-bottom-l" id="body">
        <div
          className="default-page"
          style={{ textAlign: 'left' }}
          dangerouslySetInnerHTML={{
            __html: client?.company?.privacyNotice ?? '<div></div>',
          }}
        >
          {/* {parse(client?.company?.privacyNotice ?? '<div></div>')} */}
        </div>
      </div>
    </>
  );
};
